import { types } from "../types/types";

export const setLoadingCampaniaServicios = (payload) => ({
  type: types.setLoadingCampaniaServicios,
  payload,
});

export const setLoadingCampaniaMateriales = (payload) => ({
  type: types.setLoadingCampaniaMateriales,
  payload,
});

export const setUploadingCampaniaMaterial = (payload) => ({
  type: types.setUploadingCampaniaMaterial,
  payload,
});

export const setDeletingCampaniaMaterial = (payload) => ({
  type: types.setDeletingCampaniaMaterial,
  payload,
});

export const setLoadingCampos = (payload) => ({
  type: types.setLoadingCampos,
  payload,
});
